import React, { useState, useEffect } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import useAuth from 'hooks/useAuth';
import api from "assets/services/api";



function ModalAllTabulationSellsman(props) {
    const [br, setBR] = useState(false);
    const [controlSnack, setControlSnack] = useState(false);
    const [loading, setLoading] = useState(false);
    const { storageId, user } = useAuth();

    async function download() {
        await api.get('/all/tabulation/download/' + user.id_admin + '/' + storageId, { responseType: 'blob' }).then(function (response) {
            let blob = new Blob([response.data], {
                responseType: 'arraybuffer',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/pdf',
                }
            });
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = "Tabelas dos clientes.pdf";
            link.click();
        })
            .catch(function (error) {
                console.log(error)
            });
    }
    async function download2() {

    }

    async function handleGenerate(e) {
        e.preventDefault();
        setLoading(true);
        const response = await api.get('/all/tabulation/of/client/' + user.id_admin + '/' + storageId);
        response.status === 200 ? download() : download2();
        setControlSnack(true);
        setLoading(false);
    }

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (controlSnack) {
            showNotification("br")
        }
    }, [controlSnack]);


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Gerar relatório
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleGenerate}>
                <Modal.Body>
                    <h4> Tem certeza que deseja gerar um relatório com todas as tabelas de preços? Se sim, selecione um vendedor a seguir:</h4>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        {!loading ? <Button color="success" type="submit">
                            Gerar
                        </Button> : "Carregando..."}
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Relatório gerado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalAllTabulationSellsman;